import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IUpdateDataQualityIndicatorParams {
  contentName: string;
  id: string;
  isActive: boolean;
  type: string;
  message: string;
}

export interface IUpdateDataQualityIndicatorResult extends IResult {

}

export class UpdateDataQualityIndicatorRequest extends Request<IUpdateDataQualityIndicatorParams, IUpdateDataQualityIndicatorResult> {
  constructor(params: IUpdateDataQualityIndicatorParams) {
    super('updateDataQualityIndicator', params);
  }
}
